// extracted by mini-css-extract-plugin
export default {"facebookButton":"FacebookLoginButton_facebookButton__3OoZm","facebookIcon":"FacebookLoginButton_facebookIcon__w9Gjc"};